import { VideoCallParticipantStatus } from 'messaging/calling/VideoCallParticipant'
import CallParticipantViewModel from 'messaging/calling/CallParticipantViewModel'
import { VideoRenderer } from 'messaging/calling/views/MediaRenderer'
import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Avatar from 'components/Avatar'
import Spinner from 'components/Spinner'
import styles from './ParticipantItem.sass'
import Icon from 'components/Icon'

interface ParticipantItemProps {
  vm: CallParticipantViewModel
  centerOfAttention?: boolean
  videoless?: boolean
}

/**
 * The ParticipantItem
 */
export default observer(function ParticipantItem({
  vm,
  centerOfAttention,
  videoless,
}: ParticipantItemProps) {
  const participant = vm.participant
  return (
    <div
      className={cx(
        styles.root,
        participant.status === VideoCallParticipantStatus.Connecting
          ? styles.connecting
          : participant.status !== VideoCallParticipantStatus.Connected
          ? styles.disconnected
          : undefined
      )}
    >
      <Avatar
        size={centerOfAttention ? 160 : 64}
        square
        subject={participant.member}
      />
      {!videoless && <VideoRenderer vm={vm} />}
      {!centerOfAttention && vm.isMuted && <MutedIndicator />}
      <div
        className={cx(styles.speakingIndicator, vm.speaking && styles.speaking)}
      />
      <div className={cx(styles.connectivityStatus)}>
        {participant.status === VideoCallParticipantStatus.Connecting && (
          <Spinner
            color="white"
            size={centerOfAttention ? 48 : 24}
            thickness={centerOfAttention ? 4 : 2}
          />
        )}
      </div>
    </div>
  )
})

function MutedIndicator() {
  return (
    <div className={cx(styles.mutedIndicator)}>
      <Icon
        size={18}
        width={18}
        height={18}
        color="#ffffff"
        name="call-mic-off"
      />
    </div>
  )
}
